import { useEffect, useState, useContext } from "react";
import MUIDataTable from "mui-datatables";
import requestMissingContexts from "../utils/GetContext";
import Draggable from "react-draggable";
import Paper, { PaperProps } from "@mui/material/Paper";
import {
  Chip,
  Dialog,
  DialogActions,
  Button,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import InputAdornment from "@mui/material/InputAdornment";
import { CustomerReturn } from "../../../dist/utils/reco/runners";
import { removeLeadingZeros } from "src/utils/Formatter";
import { ErrorOutline, ThumbDown, ThumbDownAltOutlined,VerifiedUser} from "@mui/icons-material";
import { prepColumns } from "./VendingVisualizer";
import { DisplayRoleContext } from "src/Context_api";

interface MaterialComponentProps {
  customer: string;
  orderState?: any;
  state: any;
  selected: any;
  isActive: boolean;
  onHover?: (matnr: string) => void;
  onPriceChange?: (matnr: string, price: number) => void;
  onOrderStateChange?: (name: string, order: string) => void;
  showRecommendation?: boolean;
}

function PaperComponent(props: PaperProps) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export default function MaterialsComponent(props: MaterialComponentProps) {

  const theme = useTheme();
  const {isDisplayOnlyRole}: any = useContext(DisplayRoleContext);

  const [codes, setCodes] = useState<any>();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalData, setModalData] = useState<any>();
  const [newPrice, setNewPrice] = useState<string>();
  let tmp = prepColumns({
    cols: {} as any,
    applyRecommended: props.showRecommendation,
    recommended: props?.state?.data?.mapd,
    replaced: props?.isActive ? [] : props?.state?.replaced,
    columns: props?.state?.data?.cmap,
    columnmap: props?.state?.data?.columns,
    reco: props.state.data.reco?props.state.data.reco.bins:'',
  });

  let data: any[] = [];

  for (let col of tmp) {
    let found = data.find(v => v.material.material_num === col.material.material_num);

    if (!found) {
      data.push(col);
    }
  }

  let total_units_per_day = 0;
  let total_rev_per_day = 0;

  for (let d of data) {
    total_units_per_day += d.material.eaches;
    total_rev_per_day += d.material.eaches * d.material.price!;
  }

  useEffect(() => {
    if (!!codes && codes.length > 0) return;

    requestMissingContexts(["BRAND", "PACKTYPE", "PACKSIZE", "BEVERAGECATEGORY"]).then((v) => {
      setCodes(v);
    });
  }, [props]);

  const getMaterialNumShort = (materialNum: string, considerIcon: boolean) => {
   // console.log(data); console.log('##########');
    const PCNT_VOL_FLAG = 0.05;
    const PCNT_REV_FLAG = 0.05;
    const mat = data.find((v: any) => v.material.material_num.localeCompare(materialNum) === 0);
    const unitsPerDay = mat.material.eaches;
    const netPerDay = mat.material.eaches * mat.material.price;

    let percentVolume: number = unitsPerDay / total_units_per_day;
    let percentRev: number = netPerDay / total_rev_per_day;

    let outOfStockSettlementsBack: string[] = [];

    if (mat.material.out_of_stock && mat.material.out_of_stock_data) {
      try {
        mat.material.out_of_stock_data = JSON.parse(mat.material.out_of_stock_data);
      } catch (err) {}

      if (mat.material.out_of_stock_data instanceof Array) {
        let idx = mat.material.out_of_stock_data.indexOf(1);

        while (idx != -1) {
          outOfStockSettlementsBack.push((idx + 1).toString());
          idx = mat.material.out_of_stock_data.indexOf(1, idx + 1);
        }
      } else {
        outOfStockSettlementsBack.push("0");
      }
    }

    let outOfStockIcon = mat.material.out_of_stock ? (
      <Tooltip
        style={{ display: "inline-block", marginLeft: theme.spacing(1) }}
        title={"OoS (# STLs Ago): " + outOfStockSettlementsBack.join(",")}
      >
        <ErrorOutline />
      </Tooltip>
    ) : (
      <div />
    );
    //console.log(mat.material.material_num); console.log( mat.protected);
    let ProtectedIcon = mat.protected ? (
      <Tooltip
        style={{ display: "inline-block", marginLeft: theme.spacing(1) }}
        title={"Protected"}
      >
        <VerifiedUser fontSize="small"/>
      </Tooltip>
    ) : (
      <div />
    );
    if (considerIcon && percentVolume <= PCNT_VOL_FLAG && !props.showRecommendation && materialNum!=='BLOCKED') {
      return (
        <div>
          {removeLeadingZeros(materialNum)}{" "}
          <Tooltip
            style={{ display: "inline-block", marginLeft: theme.spacing(1) }}
            title={`Less than ${PCNT_VOL_FLAG * 100}% of the volume`}
          >
            <div>
              <ThumbDown fontSize="small" />
            </div>
          </Tooltip>
          {outOfStockIcon}
          {ProtectedIcon}
        </div>
      );
    }

    if (considerIcon && percentRev <= PCNT_REV_FLAG && !props.showRecommendation) {
      return (
        <div>
          <Tooltip title={`Less than ${PCNT_REV_FLAG * 100}% of the Net $`}>
            <div>
              {removeLeadingZeros(materialNum)} <ThumbDownAltOutlined fontSize="small" />
            </div>
          </Tooltip>
          {outOfStockIcon}
          {ProtectedIcon}
        </div>
      );
    }

    return (
      <div>
        {removeLeadingZeros(materialNum)} {outOfStockIcon} {ProtectedIcon}
      </div>
    );
  };

  return (
    <div>
      <MUIDataTable
        options={{
          responsive: "vertical",
          selectableRows: "none",
          draggableColumns: {
            enabled: true,
          },
          sortOrder: props.orderState
            ? props.orderState
            : {
                name: "material_num",
                direction: "asc",
              },
          onColumnSortChange: (changedColumn: any, direction: any) => {
            props.onOrderStateChange && props.onOrderStateChange(changedColumn, direction);
          },
          rowsPerPageOptions: [20, 50, 100],
          rowsPerPage: 50,
          setRowProps: (row) => {
            if (row.length < 1) return {};
            if (row[0] === props.selected)
              return {
                style: {
                  background: theme.palette.highlightRow.main,
                },
              };

            return {
              onMouseOver: () => {
                props.onHover && props.onHover(row[0]);
              },
            };
          },
          elevation: 4,
        }}
        title={props.showRecommendation ? "STS Reconfiguration" : "Active in Machine"}
        columns={[
          {
            label: "key",
            name: "material_num",
            options: {
              display: 'excluded',
              filter: false,
              customBodyRender: (value: any) => value,
            },
          },
          {
            label: "Material #",
            name: "material_num",
            options: {
              filter: false,
              sort: true,
              customBodyRender: (value: any) => getMaterialNumShort(value, true),
            },
          },
          {
            label: "Description",
            name: "description",
            options: {
              filter: false,
              customBodyRender: (value: any) => value || "BLOCKED",
            },
          },
          {
            label: "Price",
            name: "price",
            options: {
              filter: false,
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div
                    onClick={() => {
                      if(isDisplayOnlyRole)
                        return;
                      setModalData({
                        data: tableMeta.rowData,
                        upd: updateValue,
                      });
                      setShowModal(true);
                    }}
                  >
                    {"$" + parseFloat(value).toFixed(2)}
                  </div>
                );
              },
            },
          },
          {
            label: "Vends/Day",
            name: "eaches",
            options: {
              filter: false,
              customBodyRender: (value: any) => parseFloat(value || 0.0).toFixed(2),
            },
          },
          {
            label: "Rev/Day",
            name: "rev",
            options: {
              filter: false,
              customBodyRender: (value: any, tableMeta) => {
                let _v: number = tableMeta.rowData[4] * tableMeta.rowData[3];
                let v = _v.toString();
                return `$${parseFloat(v || "0").toFixed(2)}`;
              },
            },
          },
          {
            label: "Days Stock",
            name: "days_stock",
            options: {
              sort: true,
              sortCompare: (order: "desc" | "asc") => (obj1: any, obj2: any) => {
                const calculateCover = (tableMeta: any) => {
                  const capacity = tableMeta.rowData[7];
                  const count = tableMeta.rowData[8];
                  const eaches = tableMeta.rowData[4];
                   if (eaches <= 0) return 0;
                  return parseFloat(((capacity * count) / eaches || 0).toFixed(2));
                };

                const cover1 = calculateCover(obj1);
                const cover2 = calculateCover(obj2);

                  return order === "desc" ? cover2 - cover1 : cover1 - cover2;
              },
              customBodyRender: (value, tableMeta) => {
                const eaches = tableMeta.rowData[4];
                if (eaches <= 0) return "N/A";
                const capacity = tableMeta.rowData[7];
                const count = tableMeta.rowData[8];

                return parseFloat(((capacity * count) / eaches || 0).toFixed(1));
              },
            },
          },
          {
            label: "Max Fill",
            name: "capacity",
            options: {
              filter: false,
            },
          },
          {
            label: "Count",
            name: "column_count",
            options: {
              filter: false,
            },
          },
        ]}
        data={data.map((v: any) => v.material)}
      />
      {showModal && (
        <Dialog
          open={showModal}
          onClose={() => {
            setShowModal(false);
          }}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            Edit Material Price
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <FormControl fullWidth variant="outlined">
                <InputLabel htmlFor="outlined-adornment-amount">Amount</InputLabel>
                <OutlinedInput
                  fullWidth
                  id="outlined-adornment-amount"
                  value={newPrice}
                  onChange={(event: any) => {
                    setNewPrice(event.target.value);
                  }}
                  startAdornment={<InputAdornment position="start">$</InputAdornment>}
                />
              </FormControl>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={() => setShowModal(false)} color="primary">
              Cancel
            </Button>
            <Button
              onClick={() => {
                props.onPriceChange && props.onPriceChange(modalData.data[0], parseFloat(newPrice as any));
                setShowModal(false);
              }}
              color="primary"
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}
